"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AsOfDate_meta_1 = require("../AsOfDate.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('section', AsOfDate_meta_1.AS_OF_DATE_CATEGORY_KEY, AsOfDate_meta_1.AS_OF_DATE_COMPONENT_KEY, ['wrapper']);